import React from 'react';
import { useIntl } from 'react-intl';

import { Chips } from '~/eds/src/components/Chips/Chips';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { Entity, EntityType } from '~/types/Entity';

type Props = {
  entity: Entity<EntityType>;
};

export const Footer = ({ entity }: Props) => {
  const intl = useIntl();

  return (
    <Layout align="center" spacing={2}>
      <Text color="text.quiet" variant="tiny">
        {intl.formatMessage({
          id: 'Footer.lookingIn',
          defaultMessage: 'Looking in:',
          description: 'Label indicating where the search is being performed',
        })}
      </Text>
      <Chips
        chips={[
          {
            text: intl.formatMessage({
              id: 'Footer.thisDocument',
              defaultMessage: 'This Document',
              description:
                'Chip label for searching within the current document',
            }),
            disabled:
              entity.type !== 'document_handler' &&
              entity.type !== 'document_version',
          },
          {
            text: intl.formatMessage({
              id: 'Footer.allDocuments',
              defaultMessage: 'All Documents',
              description: 'Chip label for searching across all documents',
            }),
            disabled: entity.type !== 'all_documents',
          },
          {
            text: intl.formatMessage({
              id: 'Footer.documentGroup',
              defaultMessage: 'Document Group',
              description: 'Chip label for document group search feature',
            }),
            disabled: true,
            tooltip: intl.formatMessage({
              id: 'Footer.comingSoon',
              defaultMessage: 'Coming Soon',
              description: 'Tooltip indicating feature is not yet available',
            }),
          },
        ]}
      />
    </Layout>
  );
};
